export const PSS = [
  "been upset because of something that happened unexpectedly?",
  "felt that you were unable to control the important things in your life?",
  "felt nervous and stressed?",
  "felt confident about your ability to handle your personal problems?",
  "felt that things were going your way?",
  "found that you could not cope with all the things that you had to do?",
  "been able to control irritations in your life?",
  "felt that you were on top of things?",
  "been angered because of things that happened that were outside of your control?",
  "felt difficulties were piling up so high that you could not overcome them?",
];
export const PSS_OPTIONS = ["Never", "Almost never", "Sometimes", "Fairly often", "Very often"];
const REVERSED = new Set([3, 4, 6, 7]);

export const pssScore = (answers) => answers.reduce((s, a, i) => s + (REVERSED.has(i) ? 4 - a : a), 0);

export const STRESS_BANDS = {
  low: { label: "Low stress", emoji: "🌿", bg: "#E9F6EC", ink: "#24452D", tips: ["Keep doing what's working: notice what helps you stay steady.", "A short daily check-in can help you catch stress early."] },
  moderate: { label: "Moderate stress", emoji: "🌤️", bg: "#FFF4DF", ink: "#5A4520", tips: ["Try a 1-minute breathing break when stress builds.", "A worry dump can help untangle what's in your control.", "Protect your sleep. Stress feels bigger when you're tired."] },
  high: { label: "High stress", emoji: "🌧️", bg: "#FCE7EF", ink: "#6B2440", tips: ["You've been carrying a lot. Please be gentle with yourself.", "Consider talking to someone you trust, a doctor or a counsellor.", "Small resets help: a physiological sigh, a short walk, water, rest."] },
};

export const stressBand = (score) => (score <= 13 ? "low" : score <= 26 ? "moderate" : "high");
